import axios from 'axios';
import {
  API_INVENTORY_BASE_URL,
  API_PROJECT_BASE_URL,
  API_TASK_BASE_URL,
  API_USER_BASE_URL,
} from '../../apiConstant';
import {
  getDateModifiedFormat2,
  getDateModifiedFormat3,
} from '../commonUtils';

const today = new Date();
const yearStart = new Date(today.getFullYear(), 0, 1);
const yyyy = today.getFullYear();

const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
/**
 * Get one materials indent by ID
 */
export const getOneMaterialsIndent = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Update material indent PO logistic
 */
export const materialIndentUpdatePoLogistic = async (data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/materialIndent/updatePoLogistic`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};
//dashboard

export const getDashboardItemsCount = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/dashboardDetails/itemsCount`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const dashboardProjectDetails = async (data) => {
  try {
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/dashboard/getProjectCount?`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get project tags
 */
export const getProjectTags = async () => {
  try {
    const resp = await axios.get(`${API_PROJECT_BASE_URL}/api/projectTags`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getFYOptions = async () => {
  try {
    const resp = await axios.get(`${API_PROJECT_BASE_URL}/api/projectDetails/financial-years`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Create project tag
 */
export const createProjectTag = async (tagName) => {
  try {
    const resp = await axios.post(`${API_PROJECT_BASE_URL}/api/projectTags`, {
      tagName,
    });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboardDetails = async (
  opts = {
    fromDate: getDateModifiedFormat2(yearStart),
    toDate: getDateModifiedFormat2(today),
    projectId: '',
  }
) => {
  try {
    let url = `${API_INVENTORY_BASE_URL}/dashboardDetails/byTime?fromDate=${opts.fromDate}&toDate=${opts.toDate}`;
    if (opts.projectId) {
      url += `&projectId=${opts.projectId}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboardOverviewData = async (
  opts = {
    fromDate: getDateModifiedFormat2(yearStart),
    toDate: getDateModifiedFormat2(today),
    projectId: '',
  }
) => {
  try {
    let url = `${API_PROJECT_BASE_URL}/api/dashboard/companyOverview?fromDate=${opts.fromDate}&toDate=${opts.toDate}`;
    if (opts.projectId) {
      url += `&projectId=${opts.projectId}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboardLabourPayment = async (
  opts = {
    fromDate: getDateModifiedFormat2(monthStart),
    toDate: getDateModifiedFormat2(today),
    projectId: '',
  }
) => {
  try {
    const cleanFromDate = opts.fromDate?.split('T')[0]?.split('+')[0];
    const cleanToDate = opts.toDate?.split('T')[0]?.split('+')[0];

    let url = `${API_PROJECT_BASE_URL}/api/dashboard/summary?startDate=${cleanFromDate}&endDate=${cleanToDate}`;
    if (opts.projectId) {
      url += `&projectId=${opts.projectId}`;
    }

    const resp = await axios.get(url);

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboardPayments = async (
  opts = {
    fromDate: getDateModifiedFormat3(yearStart),
    toDate: getDateModifiedFormat3(today),
  }
) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/dashboardDetails/payments?fromDate=${opts.fromDate}&toDate=${opts.toDate}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboardTasks = async (
  opts = {
    fromDate: getDateModifiedFormat2(yearStart),
    toDate: getDateModifiedFormat2(today),
    projectId: '',
  }
) => {
  try {
    let url = `${API_TASK_BASE_URL}/api/dashboard/taskWise?fromDate=${opts?.fromDate}&toDate=${opts?.toDate}`;
    if (opts?.projectId) {
      url += `&projectId=${opts.projectId}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboardRoles = async () => {
  try {
    const resp = await axios.get(`${API_USER_BASE_URL}/api/role/stats`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getDashboadPoBill = async (
  opts = {
    fromDate: getDateModifiedFormat2(monthStart),
    toDate: getDateModifiedFormat2(today),
    projectId: '',
  }
) => {
  try {
    const cleanFromDate = opts.fromDate?.split('T')[0]?.split('+')[0];
    const cleanToDate = opts.toDate?.split('T')[0]?.split('+')[0];

    let url = `${API_INVENTORY_BASE_URL}/poBill/company/details?startDate=${cleanFromDate}&endDate=${cleanToDate}`;
    if (opts.projectId) {
      url += `&projectId=${opts.projectId}`;
    }

    const resp = await axios.get(url);

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectMonthWise = async (
  opts = {
    fromDate: getDateModifiedFormat2(yearStart),
    toDate: getDateModifiedFormat2(today),
  }
) => {
  try {
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/dashboard/projectMonthWise?fromDate=${opts?.fromDate}&toDate=${opts?.toDate}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getItemsPurchasedMonthly = async (inId, projectId = '') => {
  try {
    let url = `${API_INVENTORY_BASE_URL}/dashboardDetails/itemsPurchasedMonthly?year=${yyyy}&inventoryId=${inId}`;
    if (projectId) {
      url += `&projectId=${projectId}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

// Accounts API

export const getIncomingPayments = async (
  opts = {
    fromDate: getDateModifiedFormat2(monthStart),
    toDate: getDateModifiedFormat2(today),
  }
) => {
  try {
    const cleanFromDate = opts.fromDate?.split('T')[0]?.split('+')[0];
    const cleanToDate = opts.toDate?.split('T')[0]?.split('+')[0];

    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/dashboard/company-summary?startDate=${cleanFromDate}&endDate=${cleanToDate}&labourStart=${cleanFromDate}&labourEnd=${cleanToDate}`
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOutgoingPayments = async (
  opts = {
    fromDate: getDateModifiedFormat2(monthStart),
    toDate: getDateModifiedFormat2(today),
  }
) => {
  try {
    const cleanFromDate = opts.fromDate?.split('T')[0]?.split('+')[0];
    const cleanToDate = opts.toDate?.split('T')[0]?.split('+')[0];

    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill/details?startDate=${cleanFromDate}&endDate=${cleanToDate}`
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPartPaymentsByID = async (id) => {
  try {
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/partPayments/${id}`
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getLabourPartPaymentsByID = async (id) => {
  try {
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/labourPartPayments/${id}`
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoPaymentsByID = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill?poBillId=${id}`
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectIDList = async () => {
  try {
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/projectDetails/id-name`
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

// delete Project

export const deleteProject = async (projectId) => {
  try {
    const response = await axios.delete(
      `${API_PROJECT_BASE_URL}/api/projectDetails/deleteProject/${projectId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting project:', error);
    throw error;
  }
};

export const getReadyForLogistics = async ({
  pageNumber = 0,
  pageSize = 100,
  search = '',
  start = '',
  end = '',
}) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/indentedMaterialQuantities/LOGISTIC`,
      {
        params: {
          pageNumber,
          pageSize,
        },
      }
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    }

    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const getReadyForPo = async ({
  pageNumber = 0,
  pageSize = 100,
  search = '',
  start = '',
  end = '',
}) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/indentedMaterialQuantities/po`,
      {
        params: {
          pageNumber,
          pageSize,
        },
      }
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    }

    return resp.data;
  } catch (error) {
    throw error;
  }
};

// export const getExpenseById = async (id) => {
//   try {
//     if (!id) {
//       throw new Error('Expense ID is required');
//     }

//     const resp = await axios.get(
//       `${API_INVENTORY_BASE_URL}/internalPurchase/byId`,
//       {
//         params: { id },
//       }
//     );

//     if (resp.data?.pmsExceptionCode) {
//       throw resp.data;
//     }

//     return resp.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const createInternalPurchasePayment = async (payload) => {
  try {
    if (!payload?.internalPurchaseId) {
      throw new Error('internalPurchaseId is required');
    }

    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/internalPurchasePayment`,
      payload
    );

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    }

    return resp.data;
  } catch (error) {
    throw error;
  }
};

// reports

export const downloadPOReport = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/getPoPdfByDate?fromDate=${fromDate}&toDate=${toDate}`,
    'Purchase_Order.pdf'
  );

/* 1. Material Indent */
export const downloadMaterialIndentPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/getMiPdfByDate?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Indent.pdf'
  );

/* 2. Material Consumption */
export const downloadMaterialConsumptionPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/materialConsumptionPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Consumption_Report.pdf'
  );

/* 3. Material Inward */
export const downloadMaterialInwardPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/materialInwardPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Inward_Report.pdf'
  );

/* 4. Labour Work Info */
export const downloadLabourWorkInfoPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_PROJECT_BASE_URL}/api/labour/workOrder/getLabourWorkInfoPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Labour_Work_Info.pdf'
  );

/* 5. Material Outward */
export const downloadMaterialOutwardPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/materialInwardOutwardPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Outward_Report.pdf'
  );

/* 6. Operation Document */
export const downloadOperationDocumentPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_PROJECT_BASE_URL}/api/labour/workOrder/getOperationDocumentPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Operation_Document.pdf'
  );

/* 7. Material Issue Register */
export const downloadMaterialIssueRegisterPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/materialIssueRegisterPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Issue_Register.pdf'
  );

/* 8. Purchase Requisition */
export const downloadPurchaseRequisitionPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/purchaseRequisitionPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Purchase_Requisition.pdf'
  );

/* 9. Tools and Equipments */
export const downloadToolsAndEquipmentsPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/toolsAndEquipmentsPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Tools_And_Equipments.pdf'
  );

/* 10. Material Stock Register */
export const downloadMaterialStockRegisterPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/materialStockRegisterPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Stock_Register.pdf'
  );

/* 11. Material Inspection Record */
export const downloadMaterialInspectionRecordPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/materialInspectionRecordPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Material_Inspection_Record.pdf'
  );

/* 12. Bill of Material */
export const downloadBillOfMaterialPdf = ({ fromDate, toDate }) =>
  downloadPdf(
    `${API_INVENTORY_BASE_URL}/reports/billOfRecordsPdf?fromDate=${fromDate}&toDate=${toDate}`,
    'Bill_Of_Material.pdf'
  );

const downloadPdf = async (url, fileName, params = {}) => {
  try {
    const response = await axios.get(url, {
      params,
      responseType: 'blob',
      validateStatus: () => true,
    });

    const contentType = response.headers['content-type'];
    if (!contentType?.includes('application/pdf')) {
      const errorText = await response.data.text();
      let message = 'Failed to generate PDF';

      try {
        const parsed = JSON.parse(errorText);
        message = parsed?.message || parsed?.error || message;
      } catch {
        message = errorText || message;
      }

      window.triggerAlert({
        title: 'Warning',
        type: 'warning',
        message,
      });
      return;
    }

    const blob = new Blob([response.data], {
      type: 'application/pdf',
    });

    const pdfUrl = window.URL.createObjectURL(blob);
    window.open(pdfUrl, '_blank');
    setTimeout(() => {
      window.URL.revokeObjectURL(pdfUrl);
    }, 5000);
  } catch (error) {
    console.error('PDF request failed:', error);
    window.triggerAlert({
      title: 'Warning',
      type: 'warning',
      message: error?.message || 'Failed to open PDF',
    });
  }
};
export const getProjectTypes = async () => {
  try {
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/projectType/list?size=1000`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data?.content || [];
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectOtherTypes = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/configuration/projectOtherTypes`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getClientProjectTypes = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/configuration/clientProjectTypes`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPropositionedProjectTypes = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/configuration/propositionedProjectTypes`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getRegistrationProjectTypes = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/configuration/registrationProjectTypes`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Create Labour Pricing (attendance-type)
 */
export const createLabourPricing = async (data) => {
  try {
    const resp = await axios.post(
      `${API_PROJECT_BASE_URL}/api/attendance-type`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get Labour Pricing List (attendance-type/company)
 */
export const getLabourPricingList = async (pID) => {
  try {
    console.log(pID)
    const resp = await axios.get(
      `${API_PROJECT_BASE_URL}/api/attendance-type/company?projectId=${pID}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Update Labour Pricing (attendance-type/{id})
 */
export const updateLabourPricing = async (id, data) => {
  try {
    const resp = await axios.put(
      `${API_PROJECT_BASE_URL}/api/attendance-type/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Create Department
 */
export const createDepartment = async (departmentName) => {
  try {
    const resp = await axios.post(`${API_USER_BASE_URL}/api/department`, {
      departmentName,
    });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Update Department
 */
export const updateDepartment = async (id, departmentName) => {
  try {
    const resp = await axios.put(`${API_USER_BASE_URL}/api/update-dept/${id}`, {
      departmentName,
    });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get Departments List
 */
export const getDepartments = async () => {
  try {
    const resp = await axios.get(`${API_USER_BASE_URL}/api/department`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Create Sub Department
 */
export const createSubDepartment = async (data) => {
  try {
    const resp = await axios.post(`${API_USER_BASE_URL}/api/sub-department/add-subDepartment`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Update Sub Department
 */
export const updateSubDepartment = async (id, data) => {
  try {
    const resp = await axios.put(`${API_USER_BASE_URL}/api/sub-department/${id}`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get Sub Departments List
 */
export const getSubDepartments = async (opts = {}) => {
  try {
    const { page = 0, size = 10 } = opts;
    const resp = await axios.get(`${API_USER_BASE_URL}/api/sub-department/getall?page=${page}&size=${size}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Delete Labour Pricing (attendance-type/{id})
 */
export const deleteLabourPricing = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_PROJECT_BASE_URL}/api/attendance-type/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get Expense Types List
 */
export const getExpenseTypes = async (opts = {}) => {
  try {
    const { page = 0, size = 10, search = '' } = opts;
    const url = `${API_INVENTORY_BASE_URL}/expenseType/list?search=${encodeURIComponent(search)}&page=${page}&size=${size}`;
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Create Expense Type
 */
export const createExpenseType = async (name) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/expenseType`, {
      name,
    });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Update Expense Type
 */
export const updateExpenseType = async (expenseTypeId, name) => {
  try {
    const resp = await axios.put(`${API_INVENTORY_BASE_URL}/expenseType`, {
      expenseTypeId,
      name,
    });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Delete Expense Type
 */
export const deleteExpenseType = async (expenseTypeId) => {
  try {
    const resp = await axios.delete(`${API_INVENTORY_BASE_URL}/expenseType/${expenseTypeId}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};
